/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileTypeMarkupIcon16Light } from './FileTypeMarkupIcon16Light';
import { FileTypeMarkupIcon16Regular } from './FileTypeMarkupIcon16Regular';
import { FileTypeMarkupIcon16Solid } from './FileTypeMarkupIcon16Solid';
import { FileTypeMarkupIcon20Light } from './FileTypeMarkupIcon20Light';
import { FileTypeMarkupIcon20Regular } from './FileTypeMarkupIcon20Regular';
import { FileTypeMarkupIcon20Solid } from './FileTypeMarkupIcon20Solid';
import { FileTypeMarkupIcon24Regular } from './FileTypeMarkupIcon24Regular';
import { FileTypeMarkupIcon24Solid } from './FileTypeMarkupIcon24Solid';
import { FileTypeMarkupIcon32Regular } from './FileTypeMarkupIcon32Regular';
import { FileTypeMarkupIcon64Regular } from './FileTypeMarkupIcon64Regular';
var sizes = {
    16: {
        light: FileTypeMarkupIcon16Light,
        regular: FileTypeMarkupIcon16Regular,
        solid: FileTypeMarkupIcon16Solid,
    },
    20: {
        light: FileTypeMarkupIcon20Light,
        regular: FileTypeMarkupIcon20Regular,
        solid: FileTypeMarkupIcon20Solid,
    },
    24: {
        regular: FileTypeMarkupIcon24Regular,
        solid: FileTypeMarkupIcon24Solid,
    },
    32: {
        regular: FileTypeMarkupIcon32Regular,
    },
    64: {
        regular: FileTypeMarkupIcon64Regular,
    },
};
export var FileTypeMarkupIcon = forwardRef('FileTypeMarkupIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
